import type { Profile } from '@gobingebox/shared';
import { apiFetch } from '@/lib/api';

export interface ProfileInput {
  name?: string;
  avatarColor?: string;
  isKids?: boolean;
}

export const profilesApi = {
  list: () => apiFetch<{ profiles: Profile[] }>('/me/profiles'),
  create: (input: ProfileInput) =>
    apiFetch<{ profile: Profile }>('/me/profiles', { method: 'POST', body: JSON.stringify(input) }),
  update: (id: string, input: ProfileInput) =>
    apiFetch<{ ok: boolean }>(`/me/profiles/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  remove: (id: string) => apiFetch<{ ok: boolean }>(`/me/profiles/${id}`, { method: 'DELETE' }),
  select: (id: string) =>
    apiFetch<{ ok: boolean; profile: Profile }>(`/me/profiles/${id}/select`, {
      method: 'POST',
      body: JSON.stringify({}),
    }),
};
